export default "__VITE_ASSET__BAmNaJYW__"